var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 39.9997C8 33.3331 9.48333 27.2164 12.45 21.6497C15.4167 16.0831 19.4 11.4664 24.4 7.79974L29.1 14.1997C25.1 17.1331 21.9167 20.8331 19.55 25.2997C17.1833 29.7664 16 34.6664 16 39.9997H8ZM80 39.9997C80 34.6664 78.8167 29.7664 76.45 25.2997C74.0833 20.8331 70.9 17.1331 66.9 14.1997L71.6 7.79974C76.6 11.4664 80.5833 16.0831 83.55 21.6497C86.5167 27.2164 88 33.3331 88 39.9997H80ZM16 75.9997V67.9997H24V39.9997C24 34.4664 25.6667 29.5497 29 25.2497C32.3333 20.9497 36.6667 18.1331 42 16.7997V13.9997C42 12.3331 42.5833 10.9164 43.75 9.74974C44.9167 8.58308 46.3333 7.99974 48 7.99974C49.6667 7.99974 51.0833 8.58308 52.25 9.74974C53.4167 10.9164 54 12.3331 54 13.9997V16.7997C59.3333 18.1331 63.6667 20.9497 67 25.2497C70.3333 29.5497 72 34.4664 72 39.9997V67.9997H80V75.9997H16ZM48 87.9997C45.8 87.9997 43.9167 87.2164 42.35 85.6497C40.7833 84.0831 40 82.1997 40 79.9997H56C56 82.1997 55.2167 84.0831 53.65 85.6497C52.0833 87.2164 50.2 87.9997 48 87.9997ZM32 67.9997H64V39.9997C64 35.5997 62.4333 31.8331 59.3 28.6997C56.1667 25.5664 52.4 23.9997 48 23.9997C43.6 23.9997 39.8333 25.5664 36.7 28.6997C33.5667 31.8331 32 35.5997 32 39.9997V67.9997Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEmptyState);
export default __webpack_public_path__ + "static/media/notification_empty_state.3bef14966c2c77fca7dc3403f4e2c211.svg";
export { ForwardRef as ReactComponent };